import { Button } from "@/design-system";
import { useVerifyEmailQuery } from "@/api/queries";
import { useScreenTitle } from "@/lib/use-screen-title";

import { AuthLayout } from "./AuthLayout";

export interface VerifyEmailProps {
  token: string | null;
  onLogin: () => void;
  onHome: () => void;
}

export function VerifyEmail({ token, onLogin, onHome }: VerifyEmailProps) {
  useScreenTitle("Conferma email");
  // useQuery keys by token so StrictMode mount-unmount-remount in dev doesn't
  // re-fire the verify call (the endpoint is single-use; a second call would
  // 400 and overwrite the first call's success state).
  const verify = useVerifyEmailQuery(token);

  if (!token) {
    return (
      <AuthLayout title="Link non valido" onBack={onHome}>
        <p className="text-[14px] leading-[1.55] text-ink-muted mb-5">
          Il link di conferma non è completo. Apri il messaggio nell&apos;email
          e prova di nuovo.
        </p>
        <Button variant="ghost" onClick={onHome}>
          Torna alla home
        </Button>
      </AuthLayout>
    );
  }

  if (verify.isPending) {
    return (
      <AuthLayout title="Sto confermando…" onBack={onHome}>
        <p className="text-[14px] leading-[1.55] text-ink-muted">
          Un attimo, sto verificando il tuo link.
        </p>
      </AuthLayout>
    );
  }

  if (verify.isError) {
    const msg = verify.error instanceof Error ? verify.error.message : "";
    const expired = msg.includes("token_expired");
    return (
      <AuthLayout title="Link non valido" onBack={onHome}>
        <p className="text-[14px] leading-[1.55] text-ink-muted mb-5">
          {expired
            ? "Questo link è scaduto. Accedi e te ne invieremo uno nuovo."
            : "Questo link non è più valido o è stato già usato."}
        </p>
        <Button variant="primary" onClick={onLogin}>
          Vai al login
        </Button>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Email confermata"
      subtitle="Ora puoi accedere e iniziare la conversazione con MIMIR."
      onBack={onHome}
    >
      <Button variant="primary" full onClick={onLogin}>
        Accedi
      </Button>
    </AuthLayout>
  );
}
